import React, { Component, Children, cloneElement } from 'react'
import PropTypes from 'prop-types'

class FileThemeTreeNodeRenderer extends Component {
	render() {
		const {
			children,
			listIndex,
			swapFrom,
			swapLength,
			swapDepth,
			scaffoldBlockPxWidth,
			lowerSiblingCounts,
			connectDropTarget,
			isOver,
			draggedNode,
			canDrop,
			treeIndex,
			getPrevRow, // Delete from otherProps
			node, // Delete from otherProps
			path, // Delete from otherProps
			treeId, // Delete from otherProps
			rowDirection, // SA
			...otherProps
		} = this.props

		const { activeId } = this.props.children.props

		let classNames = `o-sortable-tree__node o-sortable-tree__node--level-${path.length}`
		classNames =
			swapFrom === listIndex ? `${classNames} is-dragging` : classNames

		if (node.id === activeId) {
			classNames += ' is-active'
		}

		if (node.isDirectory) {
			classNames += ' is-parent'
		}

		if (node.children && !node.expanded) {
			const activeChild = node.children.find(
				child => child.id === activeId
			)
			const activeChildsChild = node.children.find(child => {
				if (child.children) {
					return child.children.find(c => c.id === activeId)
				}

				return null
			})

			if (activeChild || activeChildsChild) {
				classNames += ' has-active-child'
			}
		}

		return connectDropTarget(
			<div {...otherProps} className={classNames}>
				{Children.map(children, child =>
					cloneElement(child, {
						isOver,
						canDrop,
						draggedNode,
						lowerSiblingCounts,
						listIndex,
						swapFrom,
						swapLength,
						swapDepth,
					})
				)}
			</div>
		)
	}
}

FileThemeTreeNodeRenderer.defaultProps = {
	swapFrom: null,
	swapDepth: null,
	swapLength: null,
	canDrop: false,
	draggedNode: null,
}

FileThemeTreeNodeRenderer.propTypes = {
	treeIndex: PropTypes.number.isRequired,
	swapFrom: PropTypes.number,
	swapDepth: PropTypes.number,
	swapLength: PropTypes.number,
	scaffoldBlockPxWidth: PropTypes.number.isRequired,
	lowerSiblingCounts: PropTypes.arrayOf(PropTypes.number).isRequired,

	listIndex: PropTypes.number.isRequired,
	children: PropTypes.node.isRequired,

	// Drop target
	connectDropTarget: PropTypes.func.isRequired,
	isOver: PropTypes.bool.isRequired,
	canDrop: PropTypes.bool,
	draggedNode: PropTypes.shape({}),

	// used in dndManager
	getPrevRow: PropTypes.func.isRequired,
	node: PropTypes.shape({}).isRequired,
	path: PropTypes.arrayOf(
		PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	).isRequired,
}

export default FileThemeTreeNodeRenderer
